/**
 * Created by lito on 2018/3/27.
 */
import Vuex from 'vuex'
import Vue from 'vue'
import {getLoginInfo,setLoginInfo} from '../util/util'
Vue.use(Vuex);
const localStorage  = window.localStorage;
export default new Vuex.Store({
       state: {
         isLoading:false,
         isAjaxfail:false,
         userInfo: {'a':1}
       },
       getters:{
         getUserInfo(state){
          var userinfo  =  state.userInfo;
          if(userinfo.urid)
          {
            return userinfo;
          }else{
            var userInfo  =  localStorage.getItem("userInfo");
            return JSON.parse(userInfo);
          }
         }
       },
       mutations: {
         updateLoadingStatus (state, payload) {
           state.isLoading = payload.isLoading
         },
         updateAjaxStatus(state, payload){
           state.isAjaxfail = payload.isAjaxfail
         },
         setUserInfo (state, userInfo) {

           state.userInfo = userInfo
           //remove Lao的
           localStorage.removeItem("userInfo");
           localStorage.setItem('userInfo', JSON.stringify(userInfo));

         }

       }

});



// WEBPACK FOOTER //
// ./src/store/index.js